export const isMobile = (): boolean => window.innerWidth <= 768 // Adjust the threshold as needed
